import { QueryClient } from "@tanstack/react-query";
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 60000,
        },
    },
});
